<header class="app-header">
  <div class="header-container">

    @if (isMobile) {
    <button
      #leftMenuTrigger="matMenuTrigger"
      class="hamburger-menu-sidebar"
      [matMenuTriggerFor]="leftMenu"
      [attr.aria-label]="title?.name + ' navigation'">
      <span></span>
      <span></span>
      <span></span>
    </button>
    }

    <div class="header-title" (click)="onTitleClick()" (keydown)="onTitleKeyDown($event)" tabindex="0" role="button">
      <h1>{{ title?.name }}</h1>
    </div>

    <div class="header-spacer"></div>

    <div class="header-profile">
      @if (profile) {
        <div class="header-profile-menu">
        <button class="profile-button" [matMenuTriggerFor]="profileMenu">
          <span class="profile-name">{{ profile }}</span>
          <mat-icon>account_circle</mat-icon>
        </button>
      </div>
      }
    </div>
  </div>
</header>

<mat-menu #leftMenu="matMenu" class="left-side-menu" xPosition="after">
  <div class="left-menu-panel">
    <app-left-menu></app-left-menu>
  </div>
</mat-menu>

<mat-menu #profileMenu="matMenu">
  @for (item of listMenuItems; track item) {
  <button 
    mat-menu-item 
    (click)="onMenuItemClick(item.eventName)">
    <span>{{ item.label }}</span>
  </button>
  }
</mat-menu>